"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScreenOrientation = exports.default = void 0;
var _react = require("react");
const getOrientation = () => {
  const isIOS = navigator?.userAgent.match(/iPhone|iPad|iPod/i);
  if (Boolean(isIOS)) {
    const orientation = window?.orientation;
    switch (orientation) {
      case 0:
        return 'portrait-primary';
      case -90:
        return 'landscape-primary';
      case 90:
        return 'landscape-secondary';
      case 180:
        return 'portrait-secondary';
      default:
        return 'portrait-primary';
    }
  } else {
    return window?.screen?.orientation?.type ? window.screen.orientation.type : 'portrait-primary';
  }
};
const useScreenOrientation = () => {
  const [orientation, setOrientation] = (0, _react.useState)(getOrientation());
  const updateOrientation = _ => {
    setOrientation(getOrientation());
  };
  (0, _react.useEffect)(() => {
    window.addEventListener('orientationchange', updateOrientation);
    return () => {
      window.removeEventListener('orientationchange', updateOrientation);
    };
  }, []);
  return orientation;
};
exports.useScreenOrientation = useScreenOrientation;
var _default = exports.default = useScreenOrientation;